import { setShowClientSiteModal } from '../State/showClientSiteModal';

export default () => async (dispatch) => {
  dispatch(setShowClientSiteModal(true));
}